import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Base, Heading } from '@stepstone-genesis/components';
import { Trans } from '@stepstone-platform/i18n';
export const ContentHeader = () => {
    return (_jsx(Heading, { as: "h1", variant: 'hero', children: _jsx(Trans, { i18nKey: 'loginregistration.fullscreenModalContent.header', components: [
                _jsx(Base, { as: 'span', sx: { color: 'colorActionableDefault' } }, 0),
            ] }) }));
};
//# sourceMappingURL=ContentHeader.js.map